import { isLocal } from "../config/env";

/**
 * Simple logging utility for the application
 * Provides consistent logging interface and can be easily extended
 * Logs are only output in local environments (dev server or local Docker)
 */
export const logger = {
    log: (...args) => {
        if (isLocal) {
            console.log(...args);
        }
    },
    
    error: (...args) => {
        if (isLocal) {
            console.error(...args);
        }
    },
    
    warn: (...args) => {
        if (isLocal) {
            console.warn(...args);
        }
    },
    
    info: (...args) => {
        if (isLocal) {
            console.info(...args);
        }
    },
    
    debug: (...args) => {
        if (isLocal) {
            console.debug(...args);
        }
    },

    time: (label) => {
        if (isLocal) {
            console.time(label);
        }
    },

    timeEnd: (label) => {
        if (isLocal) {
            console.timeEnd(label);
        }
    }
};